import React, {useEffect, useMemo, useState} from 'react';
import {HStack, VStack} from "native-base";
import {t} from "../../../../../../services/i18n";
import {checkRequired} from "../../../../../../services/stepperService";
import AdvanceSelect from "../../../../../common/AdvanceSelect";
import {
    messageTemplateScopes,
    NOTE_TEMPLATE_SELECT
} from "../../../../../../services/ConstHelper";
import {useDispatch, useSelector} from "react-redux";
import {dbDateFormat, dbTimeFormat, isActive, isMobile} from "../../../../../../services/Helpers";
import MessageTextFormInput from "../../../../../common/MessageTextFormInput";
import FormInput from "../../../../../common/FormInput";
import usePermissions from "../../../../../../services/Permissions";
import {fetchApi} from "../../../../../../services/HTTP";
import moment from "moment";
import orderBy from "lodash-es/orderBy";
import AppText from "../../../../../common/AppText";
import {GlobalStyleAttributes} from "../../../../../../styles/GlobalStyles";
import TextEditor from "../../../../../common/TextEditor/TextEditor";
import {Colors} from "../../../../../../styles/Colors";
import CustomCheckbox from '../../../../../common/CustomCheckbox';
import { Tooltip } from 'antd';
import CustomButtonV2 from '../../../../../common/CustomButtonV2';
import FilePreviewList from '../../../../../common/FilePreviewList';
import {GlobalConsts} from '../../../../../../styles/GlobalConsts';
import {STEPPER_CONFIRM_MODAL, UPLOAD_FILE_MODAL, openModal, updateModalRes} from '../../../../../../redux/modalManagerSlice';
import InfoTooltip from "../../../../../common/InfoTooltip";

const Note = (props) => {
    const { values, errors, setFieldValue, touched, validationObject, targetSchedule, hideTemplate, hideScheduleSelect, scheduleNoteLabel, placeholder, showPin, showOnCheckinOption, showFileUpload} = props;
    const box = useSelector(state => state.box?.box)
    const lang = useSelector(state => state.userSettings.lang)
    const lastNoteText = values.lastNoteText
    const uploadFileModalRes = useSelector(state => state.modalManager.uploadFileModal.processRes)
    const [scheduleOptions, setScheduleOptions] = useState([]);
    const [disablePinOption, setDisablePinOption] = useState(false);
    const [formTypeOptions, setFormTypeOptions] = useState([]);
    const messageTemplates = useMemo(() => box?.message_template?.filter(template => isActive(template) && template.scope === messageTemplateScopes.NOTE)?.map(template => ({...template, value: template.id, label: template.name, text: template.text.replace('{{#firstName#}}', `[${t('firstName')}]`).replace('{{#lastName#}}', `[${t('lastName')}]`)})), [box?.message_template]);
    const boxLocale = useMemo(() => lang?.language === 'Hebrew' ? 'he' : 'en', [lang])
    const timeFormat = useMemo(() => box ? box.locations_box[0].time_format : null,[box])
    const dateFormat = useMemo(() => box ? box.locations_box[0].date_format : null,[box])
    const {has} = usePermissions()
    const dispatch = useDispatch()
    const showPunchWarning = useMemo(() => has('delayPunches') && values?.users_id && targetSchedule && targetSchedule.id !== values?.schedule_id, [targetSchedule, values?.schedule_id, values?.users_id])

    useEffect(() => {
        console.log('values, errors',values, errors)
    }, [values, errors]);

    useEffect(() => {
        if(!hideScheduleSelect) getOptionalSchedules()
    }, [hideScheduleSelect]);

    useEffect(() => {
        if(showPin) {
            checkPinnedNote()
        }
    }, [showPin]);

    useEffect(() => {
        if(showFileUpload) getFormTypes()
    }, [showFileUpload]);

    useEffect(() => {
        if(!uploadFileModalRes?.files?.length) return;
        const existingFiles = values.fileInfo?.files ?? [];
        setFieldValue('fileInfo', {...(values.fileInfo ?? {}), files: [...existingFiles, ...uploadFileModalRes.files], form_type_id: uploadFileModalRes.form_type_id ?? null})
        dispatch(updateModalRes({modalName: UPLOAD_FILE_MODAL, res: null}))
    }, [uploadFileModalRes]);

    const getFormTypes = async () => {
        try {
            const res = await fetchApi('formType/list', 'GET', null, false, true);
            const options = (res || []).filter((item) => item.is_employee_form === 0).map((item) => ({...item, value: item.id, label: t(item.name)}));
            setFormTypeOptions(options)
        } catch (error) {
            console.error(error)
        }
    }

    const handleRemoveNoteFile = (file) => {
        dispatch(openModal({modalName: STEPPER_CONFIRM_MODAL, props: {
            header: t('areYouSure'),
            subheader: t('delete-file-subheader'),
            confirmText: t('confirmDeleting'),
            onConfirm: () => addRemoveFlag(file)
        }}))
    }

    const addRemoveFlag = (file) => {
        const currentFiles = values.fileInfo?.files ?? [];
        let updatedFiles
        if(file.id) {
            updatedFiles = currentFiles.map((item) => (item.id === file.id ? {...item, shouldRemove: true} : item))
        } else {
            updatedFiles = currentFiles.filter((item) => item.uid !== file.uid)
        }
        setFieldValue('fileInfo', {...(values.fileInfo ?? {}), files: updatedFiles})
    }

    const getOptionalSchedules = async () => {
        try {
            let res = await fetchApi('notes/getOptionalSchedules', 'post', {users_id: values.users_id}, false, true);
            if(targetSchedule) {
                res = [{...targetSchedule, box_category_name: targetSchedule.box_categories.name, schedule_fk: targetSchedule.id}, ...res]
                setFieldValue('schedule_id', targetSchedule.id)
            }
            let options = res.map(option => {
                const date = moment(option.date, dbDateFormat)
                const time = moment(option.time, dbTimeFormat)
                const end_time = moment(option.end_time, dbTimeFormat)
                return {...option, value: option.schedule_fk, label: (<span><span style={{fontFamily: 'PloniMedium'}}>{option.box_category_name} - </span>{date.locale(boxLocale).format(`ddd, ${dateFormat}`)}, {time.format(timeFormat)} - {end_time.format(timeFormat)}</span>)}
            })

            options = orderBy(options, [(item) => item.time], ['asc'])
            setScheduleOptions(options)
        } catch (error) {
            console.log('error', error)
        }
    }

    const checkPinnedNote = async () => {
        try {
            let pinnedNote = await fetchApi('notes/getPinnedNote', 'post', {users_id: values.users_id}, false, true);
            if (pinnedNote) {
                setDisablePinOption(pinnedNote.id !== values.id)
            }
        } catch (error) {
            console.error(error)
        }
    }
    const onTemplateChange = (selection) => {
        setFieldValue('message_template_id', selection?.value ?? null)
        setFieldValue('text', selection?.text ?? ' ')
    }

    const copyLastNote = () => {
        if (!lastNoteText) return
        if (values.id) {
            setFieldValue('text', `${values.text || ''}${values.text ? '<p><br></p>' : ''}${lastNoteText}`)
        } else {
            setFieldValue('text', lastNoteText)
        }
    }

    return (
        <VStack space={'0.5rem'}>
            {has('userNoteTemplateView') && !hideTemplate &&
            <FormInput infoTooltip={t('note-template-select-tooltip')} label={`${t('note-template')}${checkRequired('message_template_id', validationObject)}`} width={'100%'} >
                <AdvanceSelect type={NOTE_TEMPLATE_SELECT} options={messageTemplates} initValue={values.message_template_id} onChange={onTemplateChange} isClearable={true}/>
            </FormInput> }
            <FormInput label={`${t('note-input-label')}${checkRequired('text', validationObject)} ${scheduleNoteLabel ?? ''}`}
                       width={'100%'}
                       error={(touched.text && errors.text) ? errors.text : null}
                       topEndElement={lastNoteText ?
                           <CustomButtonV2 text={t('pasteTheLastNote')}
                                           iconName={'fa-copy'}
                                           onClick={copyLastNote}
                                           wrapperStyle={{width: 'fit-content'}}
                                           style={{height: 27, borderRadius: 3, borderWidth: 1, borderColor: Colors.borderColor, padding: '3px 10px', gap: 4, alignItems: 'center', justifyContent: 'center'}}
                                           textProps={{color: Colors.newDesign.mainText, fontSize: 14}}
                                           iconProps={{iconColor: Colors.newDesign.mainText, iconHoverColor: Colors.newDesign.mainText}}/>
                           : null}>
                <div style={{height: '450px'}}>
                    <TextEditor placeholder={placeholder ?? t('add-note-here-placeholder')}
                                onChange={(text) => setFieldValue('text', text)}
                                value={values.text}
                    />
                </div>
            </FormInput>
            {showOnCheckinOption &&
            <FormInput infoTooltip={t('show-note-checkin-tooltip')} label={`${t('show-note-checkin-label')}`} width={'100%'} >
                <CustomCheckbox isChecked={values.check_in} onChange={val => setFieldValue('check_in', val)} text={t('show-note-checkin-option')} />
            </FormInput>}
            {!hideScheduleSelect &&
            <FormInput infoTooltip={t('note-schedule-select-tooltip')} label={`${t('note-schedule')}${checkRequired('schedule_id', validationObject)}`} width={'100%'} helper={showPunchWarning ? t('noteEditPunchTooltip') : null}>
                <AdvanceSelect dontSort options={scheduleOptions} initValue={values.schedule_id} onChange={(val) => setFieldValue('schedule_id', val?.value ?? null)} isClearable={true}/>
            </FormInput>}
            {showPin &&
            <FormInput label={t('pin-note')} infoTooltip={t('pin-note-tooltip')} width={'100%'}>
                <CustomCheckbox disabled={disablePinOption} text={disablePinOption ? <Tooltip title={t('pin-note-disabled-tooltip')}>{t('pin-note-checkbox-text')}</Tooltip> : t('pin-note-checkbox-text')} isChecked={values.pin} onChange={(val) => setFieldValue('pin', !!val)}/>
            </FormInput>
            }
            {showFileUpload &&
            <VStack space={'0.5rem'}>
                <VStack space={'0.2rem'}>
                    <HStack>
                        <AppText fontSize={GlobalStyleAttributes.fonts.infoText} mediumFont>{t('files')}</AppText>
                        <InfoTooltip title={t('note-files-label-tooltip')} />
                    </HStack>
                    <FilePreviewList
                        files={values.fileInfo?.files ?? []}
                        formTypeOptions={formTypeOptions}
                        onRemove={handleRemoveNoteFile}
                        canRemove={has('userNoteDelete')}
                    />
                </VStack>
                <CustomButtonV2
                    type={'link'}
                    iconName={'fa-plus'}
                    text={(values.fileInfo?.files ?? []).some((file) => !file.shouldRemove) ? t('add-another-file') : t('add_file_button')}
                    onClick={() => dispatch(openModal({modalName: UPLOAD_FILE_MODAL}))}
                    iconProps={{iconSize: GlobalConsts.iconSize.XXS, iconColor: Colors.newDesign.mainBlue}}
                    textProps={{color: Colors.newDesign.mainBlue}}
                    wrapperStyle={{width: 'fit-content'}}
                />
            </VStack>
            }
        </VStack>
    );
};

export default Note;